module.exports = __webpack_public_path__ + "front/img/0_kv.65ed9d1d.png";